import * as z from "zod";

export const connectRoktOfferNetwork = {
  name: "connectRoktOfferNetwork" as const,
  input: z.object({ accountId: z.string().min(1) }),
  output: z.object({ success: z.boolean() }),
};
